var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import { toaster } from "evergreen-ui";
import { getMaterial, getAllMaterials } from "./Materials";
import * as Sentry from "@sentry/browser";
import { useNavigate } from "react-router-dom";
import debugModule from "debug";
import { ABook } from "./Library";
const debug = new debugModule("Api");
export const APIContext = React.createContext(0); //todo fix this context
export function useAPI() {
    const context = React.useContext(APIContext);
    if (context === undefined) {
        throw new Error("Context must be used within a Provider");
    }
    return context;
}
let Resources = () => {
    const [paintColours, setPaintColours] = React.useState([]);
    const [infoUrls, setInfoUrls] = React.useState([]);
    return {
        paintColours: paintColours,
        infoUrls: infoUrls,
        init: (PublicCalls) => {
            PublicCalls.jsonFetch("meterials/data/paint").then((r) => r && r.data && setPaintColours(r.data.data));
            PublicCalls.jsonFetch("meterials/data/infourl").then((r) => r && r.data && setInfoUrls(r.data.data));
        },
    };
};
export function APIProvider(props) {
    let navigate = useNavigate();
    let apiurl = process.env.AJAXURL + "/ajax.php/";
    let resources = Resources();
    const [name, setName] = React.useState(localStorage.getItem("name") || "");
    const [customer, setCustomer] = React.useState(localStorage.getItem("customer") || "");
    const [customerName, setCustomerName] = React.useState(localStorage.getItem("customerName") || "");
    const [contactName, setContactName] = React.useState(localStorage.getItem("contactName") || "");
    const [auth, setAuth] = React.useState(localStorage.getItem("auth") || false);
    const [admin, setAdmin] = React.useState(localStorage.getItem("admin") == "true" || false);
    let _responsecheck = (response) => __awaiter(this, void 0, void 0, function* () {
        if (!response)
            return null;
        let responsejson = yield response.json();
        if (response.status != 200) {
            console.error("_responsecheck", response.status, response.statusText);
            switch (response.status) {
                case 401:
                    if (responsejson.error.type != "UNAUTHENTICATED")
                        toaster.warning(responsejson.error.description);
                    setAuth(false); //forse logout
                    break;
                case 409:
                    toaster.warning(responsejson.error
                        ? responsejson.error.description
                        : response.statusText);
                    break;
                default:
                    toaster.danger(response.statusText +
                        (responsejson.error ? ": " + responsejson.error.description : ""));
                    break;
            }
            return responsejson;
        }
        return responsejson;
    });
    React.useEffect(() => {
        //if (auth === false) {
        if (!auth || auth == "false") {
            localStorage.setItem("auth", "");
            Sentry.setUser(null);
            setAdmin(false);
            navigate("/login");
        }
        else {
            // TODO maybe use some cryptografy before storing this auth token.
            localStorage.setItem("auth", auth); //auth should be astring here
            resources.init(PublicCalls);
        }
    }, [auth]);
    React.useEffect(() => {
        localStorage.setItem("admin", admin ? "true" : "");
    }, [admin]);
    React.useEffect(() => {
        localStorage.setItem("name", name);
    }, [name]);
    React.useEffect(() => {
        localStorage.setItem("customer", customer);
    }, [customer]);
    React.useEffect(() => {
        localStorage.setItem("customerName", customerName);
    }, [customerName]);
    React.useEffect(() => {
        localStorage.setItem("contactName", contactName);
    }, [contactName]);
    let jsonFetch = (what, params = null, controller = null) => __awaiter(this, void 0, void 0, function* () {
        // debug('jsonFetch', apiurl, what)
        let headers = new Headers();
        headers.set("Content-Type", "application/json");
        const requestOptions = {
            method: "GET",
            headers: headers,
            cache: "no-cache",
            credentials: "same-origin",
            signal: controller && controller.signal,
        };
        if (auth && auth !== "false")
            headers.set("Authorization", "Bearer " + auth);
        let paramstr = "";
        if (params != null) {
            paramstr = "?" + new URLSearchParams(params);
        }
        let response = _responsecheck(yield fetch(apiurl + what + paramstr, requestOptions).catch((e) => {
            if (e.name == "AbortError") {
                return null;
            }
            console.error("jsonFetch Error", e);
            toaster.danger(e.toString());
            return null;
        }));
        if (response) {
            return response;
        }
        return Promise.reject(false);
    });
    let authFetch = (what, params = null, controller = null) => __awaiter(this, void 0, void 0, function* () {
        // debug('jsonFetch', apiurl, what)
        let headers = new Headers();
        const requestOptions = {
            method: "GET",
            headers: headers,
            cache: "no-cache",
            credentials: "same-origin",
            signal: controller && controller.signal,
        };
        if (auth && auth !== "false")
            headers.set("Authorization", "Bearer " + auth);
        let paramstr = "";
        if (params != null) {
            paramstr = "?" + new URLSearchParams(params);
        }
        return yield fetch(apiurl + what + paramstr, requestOptions).catch((e) => {
            if (e.name == "AbortError") {
                return null;
            }
            console.error("jsonFetch Error", e);
            toaster.danger(e.toString());
            return null;
        });
    });
    let jsonPost = (what, data, rawdata = false, method = "POST") => __awaiter(this, void 0, void 0, function* () {
        // debug('jsonPost', apiurl, what)
        let headers = new Headers();
        if (!rawdata)
            headers.set("Content-Type", "application/json");
        const requestOptions = {
            method: method,
            headers: headers,
            cache: "no-cache",
            credentials: "same-origin",
            body: rawdata ? data : JSON.stringify(data),
        };
        if (auth && auth !== "false")
            headers.set("Authorization", "Bearer " + auth);
        let response = _responsecheck(yield fetch(apiurl + what, requestOptions).catch((e) => {
            console.error("XXXjsonPost Error", e);
            toaster.danger(e.toString());
            return null;
        }));
        if (response)
            return response;
        return Promise.reject(false);
    });
    let processAuth = (r) => {
        if (r && r.data && r.data.jwt) {
            Sentry.setUser({
                id: r.data.id,
                username: r.data.name,
                email: r.data.email,
            });
            props.onAuth(r.data);
            setName(r.data.name);
            setCustomer(r.data.isCustomer);
            setCustomerName(r.data.CustomerName);
            setContactName(r.data.ContactName);
            setAuth(r.data.jwt);
            setAdmin(r.data.isAdministrator);
            toaster.success(r.data.message);
            //Slow things down a bit
            return window.setTimeout(() => {
                return Promise.resolve(true);
            }, 1000);
        }
        return Promise.reject(r);
    };
    let PublicCalls = {
        jsonFetch: jsonFetch,
        jsonPost: jsonPost,
        authFetch: authFetch,
        auth: auth,
        name: name,
        isAuth: (() => {
            return auth == false || auth == "false" ? false : auth;
        }).bind(this),
        isAdmin: admin,
        login: (username, password) => __awaiter(this, void 0, void 0, function* () {
            const r = yield jsonPost("auth/login", {
                name: username,
                password: password,
            });
            return processAuth(r);
        }),
        processAuth: processAuth,
        logout: () => {
            setAuth(false);
            toaster.success("Logout Complete");
            return Promise.resolve(true);
        },
        verification: (phoneNumber) => __awaiter(this, void 0, void 0, function* () {
            const r = yield jsonPost("auth/verification", {
                phoneNumber: phoneNumber,
            });
            if (r && r.data) {
                if (r.data.sent) {
                    toaster.success(r.data.message);
                    return Promise.resolve(r.data);
                }
                toaster.danger(r.data.message);
            }
            return Promise.resolve(false);
        }),
        verificationCheck: (phoneNumber, check) => __awaiter(this, void 0, void 0, function* () {
            const r = yield jsonPost("auth/verificationcheck", {
                phoneNumber: phoneNumber,
                check: check,
            });
            if (r && r.data) {
                if (r.data.verified) {
                    toaster.success(r.data.message);
                    return Promise.resolve(r.data);
                }
                toaster.danger(r.data.message);
            }
            return Promise.resolve(false);
        }),
        signup: (phoneNumber, details) => __awaiter(this, void 0, void 0, function* () {
            const r = yield jsonPost("auth/signup", {
                phoneNumber: phoneNumber,
                details: details,
            });
            if (r && r.data) {
                if (r.data.success) {
                    toaster.success(r.data.message);
                    return Promise.resolve(r.data);
                }
                toaster.danger(r.data.message);
            }
            return Promise.resolve(false);
        }),
    };
    let AuthedCalls = Object.assign(PublicCalls, {
        getMaterial: (order) => {
            return getMaterial(PublicCalls, order);
        },
        getAllMaterials: (order) => {
            return getAllMaterials(PublicCalls, order);
        },
        //order
        saveorder: (order, poNumber, images, deliveryNotes) => {
            order = order.map((orderItem) => {
                let b = orderItem.book;
                if (!b.path) {
                    let temp = new ABook("", "", "", "");
                    b = Object.assign(temp, b);
                }
                orderItem.fullpath = b.path().join("/");
                return orderItem;
            });
            return PublicCalls.jsonPost("orders/new", {
                order: order,
                poNumber: poNumber,
                images: images,
                deliveryNotes: deliveryNotes,
            });
        },
        resources: resources,
    });
    let handler = {
        get(target, prop) {
            if (target[prop] !== undefined)
                return target[prop];
            toaster.danger("Login Required");
            setAuth(false);
            return Promise.resolve(false);
        },
    };
    let PublicCallsHandler = new Proxy(PublicCalls, handler);
    return (React.createElement(APIContext.Provider, { value: auth == null ? PublicCallsHandler : AuthedCalls }, props.children));
}
